import { Tooltip } from '@/components/primitives/Tooltip'

import { Row } from '../../Row'

import { useTexts } from '../useTexts'

interface Props {
  count: number
  onSelect: () => void
}

export function OrdersExecutedReschedule(props: Props) {
  const { count, onSelect } = props
  const texts = useTexts()

  return (
    <Tooltip
      textAlign="left"
      placement="right"
      title={texts.ordersExecutedReschedule}
      subtitle={texts.ordersExecutedRescheduleTooltip}
    >
      <Row
        onClick={onSelect}
        text={texts.ordersExecutedReschedule}
        value={count}
        disabled={count === 0}
        testId="plan-summary-executed-reschedule-orders"
      />
    </Tooltip>
  )
}
